// Utilities for exact A4 print-to-fit calculation using CSS zoom

const MM_TO_PX = 96 / 25.4;
const PRINT_PAD = 13 * MM_TO_PX;

export const PRINT_Wa = 210 * MM_TO_PX - PRINT_PAD * 2;
export const PRINT_Ha = 285 * MM_TO_PX - PRINT_PAD * 2;

/**
 * Resizes and scales a content container to perfectly fit in a standard A4 page layout
 */
export function fitA4Sheet(fitEl, Wa = PRINT_Wa, Ha = PRINT_Ha) {
  if (!fitEl || Wa <= 0 || Ha <= 0) return;

  fitEl.style.zoom = '1';
  let D = Wa;
  
  // Solve iteratively for correct layout height adjustments due to wrapping
  for (let i = 0; i < 8; i++) {
    fitEl.style.width = D + 'px';
    const H = fitEl.scrollHeight;
    const nextD = Math.max(Wa, H * Wa / Ha);
    if (Math.abs(nextD - D) < 0.5) {
      D = nextD;
      break;
    }
    D = nextD;
  }
  
  fitEl.style.width = D + 'px';
  
  // Apply a small safety margin below the mathematically-exact fit to prevent trailing lines
  const SAFETY_MARGIN = 0.97;
  fitEl.style.zoom = String((Wa / D) * SAFETY_MARGIN);
}

/**
 * Resets custom zoom and width sizing on the target element
 */
export function resetA4Fit(fitEl) {
  if (!fitEl) return;
  fitEl.style.zoom = '1';
  fitEl.style.width = '';
}

/**
 * Auto-scales all active print sheets
 */
export function fitAllA4Sheets() {
  fitA4Sheet(document.getElementById('report-a4-fit'));
  fitA4Sheet(document.getElementById('principal-a4-fit-1'));
  fitA4Sheet(document.getElementById('principal-a4-fit-2'));
}

/**
 * Resets all custom sheet scalings back to normal screen flow
 */
export function resetAllA4Fits() {
  resetA4Fit(document.getElementById('report-a4-fit'));
  resetA4Fit(document.getElementById('principal-a4-fit-1'));
  resetA4Fit(document.getElementById('principal-a4-fit-2'));
}
